<template>
    <v-card elevation="0">
      <v-card
        class="d-flex items-center justify-center"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        :elevation="dragover ? 20 : 2"
        style="transition: all .2s ease-in-out cursor: pointer"
      >
        <v-card-text>
          <slot />
        </v-card-text>
      </v-card>
    </v-card>
  </template>
  
  <script>
  export default {
    data: () => ({
      dragover: false,
    }),
    methods: {
      onDrop(e) {
        this.dragover = false;
  
        this.$emit("change", e.dataTransfer.files[0]);
      },
    },
  };
</script>